<template>
  <el-row class="components-popup">
    <Transition name="slideFade">
      <el-row
        v-if="visible"
        transiton="slideFade"
        class="popup-content"
        :style="{
          width: `calc(${percent})`,
          'z-index': popupLevel + 1,
          height: main.getRecordRouterList.length
            ? 'calc(100vh - 66px)'
            : 'calc( 100vh - 66px )',
        }"
      >
        <!-- ? 'calc(100vh - 90px)' -->
        <el-row class="slot-content">
          <slot />
        </el-row>
      </el-row>
    </Transition>

    <el-row
      v-if="visible && width !== 100"
      class="mask"
      :style="{
        'z-index': popupLevel,
        width: `calc(100vw)`,
        height: main.getRecordRouterList.length
          ? 'calc(100vh - 90px)'
          : 'calc( 100vh - 65px )',
      }"
      @click="close()"
    ></el-row>
  </el-row>
</template>
<script setup lang="ts">
import { ref, onMounted, watch, inject, computed } from "vue";
import { useMain } from "@/store/index";

const drawer = ref(false);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  width: {
    type: [String, Number],
    default: "100",
  },
});
// const isShowSecondaryMenu = sessionStorage.getItem("nowMenu")|| {};
// const reduce = computed(() => {
//   // D 单功能页
//   return isShowSecondaryMenu?.menuType == "D" ? "64px" : "317px";
// });

const main = useMain();

const emits = defineEmits<{
  (e: "update:visible", flag: boolean): void;
  (e: "close"): void;
}>();

const enlarge = ref(false); // 是否放大
const percent = ref("");
const showFull = ref(false);
const popupLevel = ref(1001);

const initSize = () => {
  if (+props.width > 100 || +props.width < 0) {
    percent.value = 90 + "%";
  } else {
    percent.value = +props.width + "%";
  }
};

onMounted(() => {
  if (props.width !== 100 && props.width !== "100") {
    showFull.value = true;
  }
  initSize();
});

const clickEnlarge = (data = "") => {
  if (data === "back") {
    enlarge.value = false;
    initSize();
  } else {
    enlarge.value = true;
    percent.value = 100 + "%";
  }
};

const close = () => {
  enlarge.value = false;
  initSize();
  emits("update:visible", false);
  emits("close");
};

watch(
  () => props.visible,
  async (val) => {
    document.body.style.overflow = val ? "hidden" : "";
  },
  { deep: true }
);
</script>
<style scoped lang="scss">
.components-popup .popup-content {
  background: rgb(243, 244, 245);
  overflow: hidden;
  position: fixed;
  bottom: 0;
  height: 100%;
  right: 0;
  // transition: all 0.3s linear;
  display: block;
}

.components-popup .popup-content .header {
  width: 100%;
  height: 30px;
  background: rgb(65, 79, 122);
  padding: 0 20px;
  box-sizing: border-box;
}

.components-popup .close-icon {
  width: 30px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  display: flex;
  align-items: center;
}

// 元素进入 ｜ 结束时，过渡的效果
.slideFade-enter-active,
.slideFade-leave-active {
  transition: 0.3s linear;
}

// 元素开始进入的状态 | 元素离开结束的状态
.slideFade-enter-from,
.slideFade-leave-to {
  transform: translate(100%);
  opacity: 0;
}

.components-popup .slot-content {
  padding: 10px 8px 0;
  overflow-y: auto;
  height: 100%;
  box-sizing: border-box;
  display: block;
  :deep(.components-buttom) {
    height: calc(100% - 67px);
    background-color: #fff;
    border-radius: 5px;
    margin-top: 10px;
    padding: 12px 24px;
    box-sizing: border-box;
  }
}

.components-popup .mask {
  opacity: 1;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  transition: opacity 300ms ease 0ms;
  transform-origin: 50% 50%;
  // top: 0;
  bottom: 0;
  right: 0;
  // left: 0;
  z-index: 1999;
}

:deep(.components-edit) {
  height: calc(100% - 77px);
  margin: 10px 0;
  padding: 20px;
  padding-bottom: 50px;
  background: #fff;
  border-radius: 5px;
  display: block;
  // overflow: scroll;
  position: relative;
}
</style>
